import { Icon } from './Icon'
import type { IconProps } from './Icon'
export const MenuIcon = (p: IconProps) => <Icon {...p}><path d="M3 6h18M3 12h18M3 18h18" /></Icon>
